import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAcneBodyWashGlyph from './svgs/AcneBodyWashGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var acneBodyWashGlyph = (props => useIcon(SvgAcneBodyWashGlyph, SvgAcneBodyWashGlyph, props));

export { acneBodyWashGlyph as default };
